<template lang="html">
	<div class="container-fluid p-5">
		<loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header">
						<h6>
							<button class="back-btn" type="button" @click="back()">
								<i class="fas fa-arrow-left"></i>
							</button>
							New Agent
						</h6>
					</div>
					<div class="card-body">
						<form @submit.prevent="onSubmit">
							<div v-if="message" class="alert alert-danger">{{ message }}</div>
							<div class="form-group row">
								<div class="col-md-6">
									<label for="inputName" class="col-form-label">Name <span class="text-danger">*</span></label>
									<input type="text" v-model="agentRequest.name" @blur="validationRule()" class="form-control" id="inputName">
									<small class="text-danger">{{validationData.name}}</small>
								</div>
								<div class="col-md-6">
									<label for="inputCode" class="col-form-label">Code <span class="text-danger">*</span></label>
									<input type="text" minlength="6" v-model="agentRequest.code" @blur="validationRule()" class="form-control" id="inputCode">
									<small class="text-danger">{{validationData.code}}</small>
								</div>
							</div>
							<div class="form-group row">
								<div class="col-md-6">
									<label for="inputPhone" class="col-form-label">Phone <span class="text-danger">*</span></label>
									<input type="text" v-model="agentRequest.phone" @blur="validationRule()" class="form-control" id="inputPhone">
									<small class="text-danger">{{validationData.phone}}</small>
								</div>
								<div class="col-md-6">
									<label for="inputEmail" class="col-form-label">Email <span class="text-danger">*</span></label>
									<input type="text" v-model="agentRequest.email" @blur="validationRule()" class="form-control" id="inputEmail">
									<small class="text-danger">{{validationData.email}}</small>
								</div>
							</div>
							<div class="form-group row">
								<div class="col-md-6">
									<label for="inputPassword" class="col-form-label">Password <span class="text-danger">*</span></label>
									<input type="password" v-model="agentRequest.password" @blur="validationRule()" class="form-control" id="inputPassword">
									<small class="text-danger">{{validationData.password}}</small>
								</div>
								<div class="col-md-6">
									<label for="inputRePassword" class="col-form-label">Re-Password <span class="text-danger">*</span></label>
									<input type="password" v-model="agentRequest.rePassword" @blur="validationRule()" class="form-control" id="inputRePassword">
									<small class="text-danger">{{validationData.rePassword}}</small>
								</div>
							</div>
							<button type="submit" class="btn btn-primary float-save">Submit</button>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="js">
	import {
		mapState,
		mapActions
	} from 'vuex'
	import env from '../../enviorments'
	import Loading from 'vue-loading-overlay'
	import 'vue-loading-overlay/dist/vue-loading.css';
	export default {
		name: 'agentCreate',
		metaInfo: {
            title: "Agent Create",
            titleTemplate: "%s ← BXB",
        },
		components: {
			Loading
		},
		data() {
			return {
				env,
				isLoading: false,
				fullPage: true,
				message: "",
				agentRequest: {
					name: "",
					email: "",
					phone: "",
					code: "",
					password: "",
					rePassword: ""
				},
				validationData: {
					name: "",
					phone: "",
					email: "",
					code: "",
					password: "",
					rePassword: ""
				}
			}
		},
		watch: {
			async $route(to, from) {
			},
		},
		computed: {},
		methods: {
			...mapActions({
				agentStoreAction: 'agentStoreAction',
			}),
			async onSubmit() {
				this.isLoading = true
				let validation = this.validationRule()
				if (validation == true) {
					this.isLoading = false
					return
				}
		
				const formData = new FormData();
				formData.append('name', this.agentRequest.name);
				formData.append('phone', this.agentRequest.phone);
				formData.append('email', this.agentRequest.email);
				formData.append('code', this.agentRequest.code);
				formData.append('password', this.agentRequest.password);
				formData.append('confirmed', this.agentRequest.rePassword);

				await this.agentStoreAction(
					formData
				).then(res => {
					if(res.success === true) {
						this.back()
					} else {
						this.message = res.message
					}
					this.isLoading = false
				}).catch(err => this.isLoading = true)
			},
			back() {
				this.$router.replace({ 
					path: 'agent-list', 
					query: {
						page: 1, 
						orderBy: 'desc', 
						sortKey: 'created_at', 
						name: '',
						phone: '',
						code: ''
					}
				}).catch(()=>{})
			},
			validationRule() {
				let isValidation = []
				if (this.agentRequest.name == "") {
					this.validationData.name = "The name field is required."
					isValidation.push(true)
				} else {
					this.validationData.name = ""
					isValidation.push(false)
				}
				if (this.agentRequest.phone == "") {
					this.validationData.phone = "The phone field is required."
					isValidation.push(true)
				} else {
					this.validationData.phone = ""
					isValidation.push(false)
				}
				if (this.agentRequest.email == "") {
					this.validationData.email = "The email field is required."
					isValidation.push(true)
				} else {
					this.validationData.email = ""
					isValidation.push(false)
				}

				if (this.agentRequest.code == "") {
					this.validationData.code = "The code field is required."
					isValidation.push(true)
				} else {
					if (this.agentRequest.code.length > 6) {
						this.validationData.code = "The code must be at least 6 characters."
						isValidation.push(true)
					} else {
						this.validationData.code = ""
						isValidation.push(false)
					}
				}
				if (this.agentRequest.password == "") {
					this.validationData.password = "The password field is required."
					isValidation.push(true)
				} else {
					this.validationData.password = ""
					isValidation.push(false)
				}
				if (this.agentRequest.rePassword == "") {
					this.validationData.rePassword = "The re-password field is required."
					isValidation.push(true)
				} else {
					this.validationData.rePassword = ""
					isValidation.push(false)
				}
				if (this.agentRequest.password !== this.agentRequest.rePassword) {
					this.validationData.rePassword = "The password and re-password fields must match."
					isValidation.push(true)
				}
				if (isValidation.includes(true)) {
					return true
				} else {
					return false
				}
			}
		},
		async mounted() {
		}
	}
</script>

<style scoped lang="scss">
	.v-text-field--box .v-input__slot,
	.v-text-field--outline .v-input__slot {
		min-height: 56px;
	}
	.banner-image {
		width: 100px;
		height: 100px;
		object-fit: contain;
	}
</style>